import { useState, useEffect, Component } from 'react';
import { MdChatBubble, MdClose } from 'react-icons/md';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';
import ChatWindow from './ChatWindow';
import './index.css';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Widget Error:", error, errorInfo);
    try {
      addDoc(collection(db, "widget_crashes"), {
        error: error.toString(),
        componentStack: errorInfo.componentStack,
        timestamp: serverTimestamp()
      });
    } catch (e) {
      console.error("Failed to log crash to Firestore", e);
    }
  }

  render() {
    if (this.state.hasError) {
      return <div style={{ padding: '20px', background: 'white', color: 'red', border: '1px solid red', borderRadius: '8px', position: 'fixed', bottom: '110px', right: '24px', width: '400px', zIndex: 99999 }}>
        <h3>Widget Crashed</h3>
        <p>{this.state.error && this.state.error.toString()}</p>
        <button onClick={() => this.setState({ hasError: false })}>Restart</button>
      </div>;
    }
    return this.props.children;
  }
}

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);

  // Hide the tooltip permanently once they open the chat
  useEffect(() => {
    if (isOpen) {
      setShowTooltip(false);
    }
  }, [isOpen]);

  // Optional: Auto-hide after some time to not be annoying? 
  // Let's keep it visible until they click or close it for now.

  return (
    <>
      <div style={{ display: isOpen ? 'block' : 'none' }}>
        <ErrorBoundary>
          <ChatWindow isOpen={isOpen} />
        </ErrorBoundary>
      </div>

      {/* Tooltip Popup */}
      <div 
        className={`talisman-tooltip ${showTooltip && !isOpen ? 'visible' : ''}`}
        onClick={() => setIsOpen(true)}
      >
        <div className="talisman-tooltip-content">
          <p>Hi! I'm TMan. Click here to chat with me!</p>
          <button 
            className="talisman-tooltip-close" 
            onClick={(e) => {
              e.stopPropagation();
              setShowTooltip(false);
            }} 
            aria-label="Close tooltip"
          >
            <MdClose />
          </button>
        </div>
        <div className="talisman-tooltip-arrow"></div>
      </div>
      
      <button 
        className={`talisman-chat-btn ${isOpen ? 'open' : ''}`} 
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle chat"
      >
        {isOpen ? <MdClose /> : <img src="https://talisman-ai-agent-9cb94.web.app/talisman-man.svg" alt="Chat" className="talisman-chat-icon-img" />}
      </button>
    </>
  );
}

export default App;
